"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DesktopStrategy_drawingToolsManager, _DesktopStrategy_geometryMathManager, _DesktopStrategy_insertionInteractionHandler, _DesktopStrategy_interactionManager, _DesktopStrategy_interactionManagerHelper, _DesktopStrategy_midPointInteractionHandler, _DesktopStrategy_restrictionManager, _DesktopStrategy_viewport, _DesktopStrategy_cameraFreezeFlag, _DesktopStrategy_lastEvent, _DesktopStrategy_onDownPointer;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopStrategy = void 0;
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
class DesktopStrategy {
    constructor(drawingToolsManager, interactionManager) {
        _DesktopStrategy_drawingToolsManager.set(this, void 0);
        _DesktopStrategy_geometryMathManager.set(this, void 0);
        _DesktopStrategy_insertionInteractionHandler.set(this, void 0);
        _DesktopStrategy_interactionManager.set(this, void 0);
        _DesktopStrategy_interactionManagerHelper.set(this, void 0);
        _DesktopStrategy_midPointInteractionHandler.set(this, void 0);
        _DesktopStrategy_restrictionManager.set(this, void 0);
        _DesktopStrategy_viewport.set(this, void 0);
        _DesktopStrategy_cameraFreezeFlag.set(this, "");
        _DesktopStrategy_lastEvent.set(this, void 0);
        _DesktopStrategy_onDownPointer.set(this, void 0);
        __classPrivateFieldSet(this, _DesktopStrategy_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_interactionManager, interactionManager, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_viewport, drawingToolsManager.viewport, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_geometryMathManager, __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").geometryMathManager, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_restrictionManager, __classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").restrictionManager, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_insertionInteractionHandler, __classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").insertionInteractionHandler, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_midPointInteractionHandler, __classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").midPointInteractionHandler, "f");
        __classPrivateFieldSet(this, _DesktopStrategy_interactionManagerHelper, __classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").interactionManagerHelper, "f");
    }
    get cameraFreezeFlag() {
        return __classPrivateFieldGet(this, _DesktopStrategy_cameraFreezeFlag, "f");
    }
    onDown(event, ray) {
        if (event.button === 0) {
            __classPrivateFieldSet(this, _DesktopStrategy_onDownPointer, event, "f");
            __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").moving = false;
            /**
             * IF INSERT KEY IS PRESSED
             * FINALIZE INSERTION AND START A NEW ONE
             */
            if (__classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").insertionActive === true) {
                const result = __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").finalizeInsertion();
                const distances = __classPrivateFieldGet(this, _DesktopStrategy_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").positionArray);
                __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").checkHover(distances, ray);
                if (result) {
                    __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").update();
                    return;
                }
                else {
                    __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").startInsertion(event);
                    return;
                }
            }
            const distances = __classPrivateFieldGet(this, _DesktopStrategy_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").positionArray);
            /**
             * IF MID POINT INSERTION IS ACTIVE
             * FINISH MID POINT INSERTION IF THE CURRENT INDEX IS THE MID POINT INSERTION INDEX
             */
            if (__classPrivateFieldGet(this, _DesktopStrategy_midPointInteractionHandler, "f").midPointInsertionActive ===
                true) {
                __classPrivateFieldGet(this, _DesktopStrategy_midPointInteractionHandler, "f").finishMidPointInsertion(distances);
                __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").midPointInserted = true;
            }
            /**
             * CHECK HOVERED POINT
             */
            __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").checkHover(distances, ray);
            /**
             * IF THERE IS A POINT CLOSE TO THE RAY
             */
            __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").selectPoint(distances);
            /**
             * IF THE CURRENTLY HOVERED POINT IS SELECTED
             * START DRAGGING
             */
            const draggingStarted = __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").startDragging();
            if (draggingStarted && !__classPrivateFieldGet(this, _DesktopStrategy_cameraFreezeFlag, "f"))
                __classPrivateFieldSet(this, _DesktopStrategy_cameraFreezeFlag, __classPrivateFieldGet(this, _DesktopStrategy_viewport, "f").addFlag(viewer_shared_types_1.FLAG_TYPE.CAMERA_FREEZE), "f");
        }
        else if (event.button === 2) {
            /**
             * WHEN RIGHT MOUSE BUTTON IS PRESSED
             */
            this.onOut();
        }
    }
    /**
     * On mouse move, move the selected point if there is one
     *
     * @param event
     * @param ray
     */
    onMove(event, ray) {
        let currentRestrictedPoint;
        // if there are no points, start with the insertion right away
        if (__classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").settings.general.autoStart &&
            __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").insertionActive === false &&
            __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").getPointsData().length === 0) {
            __classPrivateFieldSet(this, _DesktopStrategy_lastEvent, event, "f");
            currentRestrictedPoint =
                this.startInsertion() || currentRestrictedPoint;
        }
        // if the insertion was paused, try to start it again
        // it might not start if the ray is not intersecting with the restriction
        if (__classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").insertionPaused) {
            __classPrivateFieldSet(this, _DesktopStrategy_lastEvent, event, "f");
            currentRestrictedPoint =
                this.startInsertion() || currentRestrictedPoint;
        }
        const distanceSquared = __classPrivateFieldGet(this, _DesktopStrategy_onDownPointer, "f")
            ? Math.pow(event.clientX - __classPrivateFieldGet(this, _DesktopStrategy_onDownPointer, "f").clientX, 2) +
                Math.pow(event.clientY - __classPrivateFieldGet(this, _DesktopStrategy_onDownPointer, "f").clientY, 2)
            : Infinity;
        const clickThresholdSquared = 25;
        const pointerMoved = distanceSquared > clickThresholdSquared;
        __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").moving = pointerMoved;
        if (pointerMoved) {
            __classPrivateFieldSet(this, _DesktopStrategy_lastEvent, event, "f");
            /**
             * IF WE ARE DRAGGING A POINT
             * MOVE THE SELECTED POINTS
             */
            currentRestrictedPoint =
                __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").moveSelectedPoints(ray) ||
                    currentRestrictedPoint;
        }
        const distances = __classPrivateFieldGet(this, _DesktopStrategy_geometryMathManager, "f").checkPointDistances(ray, __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").positionArray);
        __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").checkHover(distances, ray);
        if (pointerMoved) {
            /**
             * IF INSERT KEY IS PRESSED
             * ADD POINT AT RAY INTERSECTION IF THERE IS NONE WAS ADDED
             * MOVE LAST ADDED POINT IF THERE IS ONE
             */
            currentRestrictedPoint =
                __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").onMove(ray) ||
                    currentRestrictedPoint;
            /**
             * IF INSERT KEY IS NOT PRESSED AND DRAGGING IS NOT ACTIVE
             * CHECK IF THERE IS A LINE CLOSE TO THE RAY AND ADD A MID POINT TO IT
             */
            if (__classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").insertionActive === false &&
                __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").dragging === false &&
                __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").selectedPointIndices.length === 0) {
                __classPrivateFieldGet(this, _DesktopStrategy_midPointInteractionHandler, "f").onMove(ray, __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").hoveredPoint);
            }
        }
        if (__classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").dragging) {
            document.body.style.cursor = "grabbing";
        }
        else if (__classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").hoveredPoint !== undefined) {
            document.body.style.cursor = "pointer";
        }
        else {
            document.body.style.cursor = "default";
        }
        // if the insertion is active, but the current point is not restricted, pause the insertion
        if (!currentRestrictedPoint &&
            __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").insertionActive)
            __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").pauseInsertion();
        __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").textVisualizationManager.updatePointerPosition(currentRestrictedPoint);
    }
    /**
     * On mouse out, deselect the hovered point and remove the stop dragging
     */
    onOut() {
        __classPrivateFieldGet(this, _DesktopStrategy_restrictionManager, "f").showRestrictionVisualization = false;
        __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").pauseInsertion();
        __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").onOut();
        this.reset();
    }
    onUp() {
        __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").onUp();
        this.reset();
    }
    reset() {
        if (__classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").insertionActive === false) {
            __classPrivateFieldGet(this, _DesktopStrategy_restrictionManager, "f").showRestrictionVisualization = false;
            __classPrivateFieldGet(this, _DesktopStrategy_viewport, "f").removeFlag(__classPrivateFieldGet(this, _DesktopStrategy_cameraFreezeFlag, "f"));
            __classPrivateFieldSet(this, _DesktopStrategy_cameraFreezeFlag, "", "f");
        }
        __classPrivateFieldGet(this, _DesktopStrategy_interactionManagerHelper, "f").reset();
    }
    startInsertion() {
        __classPrivateFieldGet(this, _DesktopStrategy_restrictionManager, "f").showRestrictionVisualization = true;
        __classPrivateFieldGet(this, _DesktopStrategy_midPointInteractionHandler, "f").stopMidPointInsertion();
        return __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").startInsertion(__classPrivateFieldGet(this, _DesktopStrategy_lastEvent, "f"));
    }
    stopInsertion() {
        __classPrivateFieldGet(this, _DesktopStrategy_restrictionManager, "f").showRestrictionVisualization = false;
        __classPrivateFieldGet(this, _DesktopStrategy_insertionInteractionHandler, "f").stopInsertion();
        __classPrivateFieldGet(this, _DesktopStrategy_viewport, "f").removeFlag(__classPrivateFieldGet(this, _DesktopStrategy_cameraFreezeFlag, "f"));
        __classPrivateFieldSet(this, _DesktopStrategy_cameraFreezeFlag, "", "f");
    }
    onKeyDown() {
        const insertKeyPressed = __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").settings.controls.insert);
        const cancelKeyPressed = __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").settings.controls.cancel);
        const confirmKeyPressed = __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").settings.controls.confirm);
        const deleteKeyPressed = __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").keyPressed(__classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").settings.controls.delete);
        /**
         * IF CONFIRM KEY IS PRESSED
         * - IF INSERTION IS ACTIVE, STOP INSERTION
         * - IF INSERTION IS NOT ACTIVE, UPDATE DRAWING TOOL
         */
        if (confirmKeyPressed) {
            if (__classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").insertionInteractionHandler
                .insertionActive) {
                this.stopInsertion();
                __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").update();
            }
            else {
                __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").update();
            }
        }
        /**
         * IF CANCEL KEY IS PRESSED
         * - IF INSERTION IS ACTIVE, STOP INSERTION
         * - IF INSERTION IS NOT ACTIVE, CANCEL DRAWING TOOL
         */
        if (cancelKeyPressed) {
            if (__classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").insertionInteractionHandler
                .insertionActive) {
                this.stopInsertion();
            }
            else {
                __classPrivateFieldGet(this, _DesktopStrategy_drawingToolsManager, "f").cancel();
            }
        }
        /**
         * IF INSERT KEY IS PRESSED
         * - START INSERTION
         */
        if (insertKeyPressed) {
            this.startInsertion();
        }
        /**
         * IF DELETE KEY IS PRESSED
         * - DELETE SELECTION
         */
        if (deleteKeyPressed) {
            __classPrivateFieldGet(this, _DesktopStrategy_interactionManager, "f").deleteSelection();
        }
    }
}
exports.DesktopStrategy = DesktopStrategy;
_DesktopStrategy_drawingToolsManager = new WeakMap(), _DesktopStrategy_geometryMathManager = new WeakMap(), _DesktopStrategy_insertionInteractionHandler = new WeakMap(), _DesktopStrategy_interactionManager = new WeakMap(), _DesktopStrategy_interactionManagerHelper = new WeakMap(), _DesktopStrategy_midPointInteractionHandler = new WeakMap(), _DesktopStrategy_restrictionManager = new WeakMap(), _DesktopStrategy_viewport = new WeakMap(), _DesktopStrategy_cameraFreezeFlag = new WeakMap(), _DesktopStrategy_lastEvent = new WeakMap(), _DesktopStrategy_onDownPointer = new WeakMap();
//# sourceMappingURL=DesktopStrategy.js.map